const Faqs = [
  {
    id: 1,
    question: "¿Cuánto duran los programas en Amura Centro Culinario?",
    answer: "El técnico básico tiene una duración de 2 cuatrimestres, el técnico medio de 3 cuatrimestres y el técnico profesional de 7 cuatrimestres."
  },
  {
    id: 2,
    question: "¿Cuáles son los requisitos para ingresar a Amura Centro Culinario?",
    answer: "Para ingresar a Amura debes ser mayor de 15 años. Si sos menor, debes presentarse con un padre o encargado. Tambien haber aprobado noveno año y tener mucho entusiasmo."
  },
  {
    id: 3,
    question: "¿Cuánto cuesta la carrera en Amura Centro Culinario?",
    answer: "El costo de la carrera varia por programa, el costo de matrícula es de ¢76 300, las materías prácticas (incluye los ingredientes) ¢342 300 cada una y las teóricas ¢77 000 cada una. Tambien podés financiar toda tu carrera con CONAPE."
  },
  {
    id: 4,
    question: "¿Qué horarios ofrecen en Amura Centro Culinario?",
    answer: "Tenemos horarios flexibles para que podás estudiar y trabajar al mismo tiempo. De lunes a viernes ofrecemos horarios diurnos y nocturnos. Los sábados solo horarios diurnos."
  },
  {
    id: 5,
    question: "¿Donde están ubicados?",
    answer: "Nos encontramos en Llorente de Tibás, contiguo a Grupo Nación, a solo 5 minutos del centro de San José. Los autobuses hacen parada al frente de nuestras instalaciones, lo que facilita su acceso. Además, contamos con parqueo exclusivo y seguro para vos."
  }
];

export default Faqs;